import React from "react";
const DetailCard = ({ title, info }) => {
    return <div style={{ display: "flex", flexDirection: "column", flex: 1,
        height: "80px", padding: "20px", alignItems: "center", justifyContent: "center",
        backgroundColor: "var(--grey-lighter)", borderRadius: "6px", textAlign: "center",
        gap: "20px"
    }}>
        <span style={{ textTransform: "uppercase", fontWeight: "700" }}>{title}</span>
        {info}
    </div>;
};
export default DetailCard;
